import { render, staticRenderFns } from "./NavigationMissionIconParts.vue?vue&type=template&id=1a745c96"
import script from "./NavigationMissionIconParts.vue?vue&type=script&lang=ts"
export * from "./NavigationMissionIconParts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports